module.exports = function() {
  return new Worker(__webpack_public_path__ + "6be4f22d04b5476a5603.worker.js");
};